import React from 'react';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';
import { withReactKey } from '../../../utils/withReactKey';
import {
  ldapGroupToSelectOption,
  selectedOptionsToValueLabel,
  selectionToIsToggleDisabled,
} from './dataTransformations';

interface SimulationControl {
  groups: string[];
  selected: string[];
  onSelect: (groups: string[]) => void;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const SIMULATE_LABEL = 'Simulate LDAP groups';
const GROUPS_PLACEHOLDER = 'Groups to simulate';

const SelectOptionWithReactKey = withReactKey(SelectOption);

// The label sits outside Toggle because Katal's global `.katal label` rule breaks Toggle's label layout.
const SimulationControlComponent: React.FC<SimulationControl> = ({
  groups,
  selected,
  onSelect,
  checked,
  onChange,
}) => {
  const selectOptions = groups.map(ldapGroupToSelectOption);
  return (
    <Row spacing="200" alignmentVertical="center" widths="fit">
      <Select
        value={selected}
        onChange={onSelect}
        disabled={checked}
        placeholder={GROUPS_PLACEHOLDER}
        aria-label={GROUPS_PLACEHOLDER}
        valueLabel={selectedOptionsToValueLabel}
        size="small"
        width={240}
      >
        {selectOptions.map(SelectOptionWithReactKey)}
      </Select>
      <Toggle
        checked={checked}
        onChange={onChange}
        disabled={selectionToIsToggleDisabled(checked)(selected)}
        size="small"
        aria-label={SIMULATE_LABEL}
      />
      <Text type="b200" color="inverted">
        {SIMULATE_LABEL}
      </Text>
    </Row>
  );
};

export default SimulationControlComponent;
